var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-no-wrap",class:_vm.colorClass},[_vm._v(" "+_vm._s(_vm.statusTxt)+" ")]),_c('div',{staticClass:"mt-1 g-73--text"},[_vm._v(_vm._s(_vm.timestamp))])])}
var staticRenderFns = []

export { render, staticRenderFns }